import { IPsm } from '@turnercode/types'
import { PsmVideoPlayer } from '../common/interfaces'
import PsmBridge from '../common/psm-bridge'
import TopPlayer from '../players/TopPlayer'
import { topPlayerDependencies } from '../players/TopPlayer/dependencies'
import DiscoveryPlayer from '../players/DiscoveryPlayer'
import { discoveryPlayerDependencies } from '../players/DiscoveryPlayer/dependencies'
import PsmDeviceMetadataWeb from './psm-metadata'
import { psmDependencies } from './dependencies'
import { logger } from '../utils'


// TODO: This will be where we extend the base class to add in any Browser specific functionality
// This class is the entrypoint in the dist folder at /dist/web.js

class PsmTop2Player extends PsmBridge {
  constructor(videoPlayer: PsmVideoPlayer, psm: IPsm) {
    logger('Testing Multiple Players')
    const vPlayer = new TopPlayer(videoPlayer)
    const dependencies = psmDependencies(psm)
    const playerDependencies = topPlayerDependencies(vPlayer.player)
    const metadataDependencies = { getMetadata: (playerDependencies) => new PsmDeviceMetadataWeb(playerDependencies) }
    super(vPlayer, psm, dependencies, playerDependencies, metadataDependencies)
  }
}

class PsmDiscoveryPlayer extends PsmBridge {
  constructor(videoPlayer: PsmVideoPlayer, psm: IPsm) {
    const vPlayer = new DiscoveryPlayer(videoPlayer)
    const dependencies = psmDependencies(psm)
    const playerDependencies = discoveryPlayerDependencies(vPlayer.player)
    const metadataDependencies = { getMetadata: (playerDependencies) => new PsmDeviceMetadataWeb(playerDependencies) }
    super(vPlayer, psm, dependencies, playerDependencies, metadataDependencies)
  }
}

export * from '../common/interfaces';
export const PsmDiscovery = PsmDiscoveryPlayer
export const PsmTop2 = PsmTop2Player
